"use client";

// Public entry for calendar context. Implementation lives in
// `./calendar-context-internal/*` — this shell re-exports the exact
// same public API so consumers can keep importing from `@/lib/calendar-context`.

export { CalendarProvider } from "./calendar-context-internal/provider";
export {
  useCalendarContext,
  useOptionalCalendarContext,
  useCalendarEvents,
  useCalendarEvent,
  useCalendarSources,
  useSourceColors,
  useSourceColor,
} from "./calendar-context-internal/hooks";
export type { CalendarViewType } from "./calendar-context-internal/types";
